import { PropsWithChildren } from "react";

import { Tabs } from "@design-system/Tabs/Tabs";

import { routes } from "@pages/routes";

type Props = PropsWithChildren<{
  clientId: string;
  clientEmployeeId: string;
}>;

export const ClientEmployeeTabs = ({ clientId, clientEmployeeId }: Props) => {
  return (
    <Tabs>
      <Tabs.Tab
        name="Dashboard"
        to={routes.portal.clients.client.clientEmployees.clientEmployee.dashboard.$buildPath(
          {
            params: { clientId, clientEmployeeId },
          },
        )}
      />
      <Tabs.Tab
        name="Record"
        to={routes.portal.clients.client.clientEmployees.clientEmployee.record.$buildPath(
          {
            params: { clientId, clientEmployeeId },
          },
        )}
      />
      <Tabs.Tab
        name="File Uploads"
        to={routes.portal.clients.client.clientEmployees.clientEmployee.fileUploads.$buildPath(
          {
            params: { clientId, clientEmployeeId },
          },
        )}
      />
    </Tabs>
  );
};
